import type { TGuaranteesSupervisorGroupKey } from './types.ts';

export const guaranteesSupervisorGroupKeys = [
  'usapok',
  'uo',
  'umvn',
  'udbtf',
  'uakdo',
] as const satisfies readonly TGuaranteesSupervisorGroupKey[];

export const APPLICATION_FILE_DOWNLOAD_DEFAULT_IS_ATTACHED = true;
